import o from "./index817.js";
import e from "./index910.js";
import a from "./index800.js";
import n from "./index904.js";
var p = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, s = Function.prototype, c = Object.prototype, f = s.toString, m = c.hasOwnProperty, u = RegExp(
  "^" + f.call(m).replace(p, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function O(r) {
  if (!a(r) || e(r))
    return !1;
  var t = o(r) ? u : i;
  return t.test(n(r));
}
export {
  O as default
};
